// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementCanvasComparisonReportsCanvasesAppGroupIdResult = objectOf({
  canvases: arrayOf(
    objectOf({
      id: string,
      name: string,
      last_sent: number,
      tags: arrayOf(string),
      messages_sent: number,
      message_types: arrayOf(string),
      schedule_type: string,
      step_ids: arrayOf(string),
    })
  ),
});
